var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5999 10H16.3333V6.00002C16.3333 3.05335 13.9466 0.666687 10.9999 0.666687C8.05325 0.666687 5.66658 3.05335 5.66658 6.00002V10H5.3999C2.5999 10 0.333252 12.28 0.333252 15.0667V22.2534C0.333252 25.0534 2.61324 27.32 5.3999 27.32H16.5866C19.3866 27.32 21.6532 25.04 21.6532 22.2534V15.0667C21.6532 12.2667 19.3733 10 16.5866 10H16.5999ZM8.33325 6.00002C8.33325 4.53335 9.53325 3.33335 10.9999 3.33335C12.4666 3.33335 13.6666 4.53335 13.6666 6.00002V10H8.33325V6.00002ZM18.9999 22.2667C18.9999 23.5867 17.9199 24.6667 16.5999 24.6667H5.41325C4.09325 24.6667 3.01326 23.5867 3.01326 22.2667V15.08C3.01326 13.76 4.09325 12.68 5.41325 12.68H16.5999C17.9199 12.68 18.9999 13.76 18.9999 15.08V22.2667Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.05a2202a835a12dd79ca2e1e2c56978a.svg";
export { ForwardRef as ReactComponent };